/**
 * المرحلة 1.3 — the applicant token of a doctor waiting for approval.
 *
 * Handed out at registration and at a refused sign-in (403
 * PENDING_APPLICATION); it opens /api/doctor-applications/mine and nothing
 * else, and lasts two hours. Kept for this tab only: closing it forgets the
 * token, and signing in again issues a new one.
 */

const KEY = 'capsule_applicant';

export function saveApplicant(token) {
  try {
    if (token) sessionStorage.setItem(KEY, token);
  } catch {
    // Storage refused (a private window): the page asks to sign in again.
  }
}

export function readApplicant() {
  try {
    return sessionStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

export function clearApplicant() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nothing kept
  }
}

/** The token a refused sign-in carries, if it is a doctor waiting for approval. */
export const applicantFrom = (err) =>
  err && err.status === 403 && err.body && err.body.code === 'PENDING_APPLICATION' && err.body.applicant ? err.body.applicant.token : null;
